/**
 * Float Menu Component
 */
export class FloatMenu {
    constructor() {
        // 기존 initFloatMenu 로직 유지
        if (typeof initFloatMenu === 'function') {
            initFloatMenu();
        }
    }
}

